import {
  UPLOAD_BENEFICIARIES_REQUEST,
  UPLOAD_BENEFICIARIES_SUCCESS,
  UPLOAD_BENEFICIARIES_FAILURE,
  FETCH_BENEFICIARIES_REQUEST,
  FETCH_BENEFICIARIES_SUCCESS,
  FETCH_BENEFICIARIES_FAILURE,
  DOWNLOAD_TEMPLATE_REQUEST,
  DOWNLOAD_TEMPLATE_SUCCESS,
  DOWNLOAD_TEMPLATE_FAILURE,
  SET_UPLOAD_PROGRESS,
} from "../../actions/survey-management/beneficiariesActions";

const initialState = {
  loading: false,
  beneficiaries: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  },
  surveyStats: {
    totalSurvey: 0,
    surveyedCount: 0,
    pendingCount: 0,
  },
  uploadProgress: 0,
  error: null,
  lastUpload: null,
};

const beneficiariesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_BENEFICIARIES_REQUEST:
    case FETCH_BENEFICIARIES_REQUEST:
    case DOWNLOAD_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPLOAD_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        loading: false,
        lastUpload: action.payload,
        error: null,
      };

    case FETCH_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        loading: false,
        beneficiaries: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        surveyStats: action.payload.surveyStats || state.surveyStats,
        error: null,
      };

    case DOWNLOAD_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload,
      };

    case UPLOAD_BENEFICIARIES_FAILURE:
    case FETCH_BENEFICIARIES_FAILURE:
    case DOWNLOAD_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default beneficiariesReducer;
